module.exports = __webpack_public_path__ + "assets/img/lx_w_d_i_15.c25ce117.jpg";